var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal7List(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11812",
    "data-name": "Rectangle 11812",
    width: 7.893,
    height: 7.883,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-External_3_List"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "External_3_List",
    "data-name": "External 3_List",
    clipPath: "url(#clip-External_3_List)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_667",
    "data-name": "Ellipse 667",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(1 1)",
    fill: "#f36d54"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_20392",
    "data-name": "Group 20392",
    transform: "translate(5.554 5.559)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15831",
    "data-name": "Group 15831",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32843",
    "data-name": "Path 32843",
    d: "M0,43.014a1.381,1.381,0,0,1,.289-.645,1.284,1.284,0,0,1,.968-.483c.583-.021,1.166,0,1.749-.008a.5.5,0,0,1,.37.125.448.448,0,0,1,.109.488.442.442,0,0,1-.413.282q-.867,0-1.734,0a.451.451,0,0,0-.269.079.44.44,0,0,0-.185.385q0,1.023,0,2.046,0,1.119,0,2.238a.442.442,0,0,0,.486.488H5.647a.437.437,0,0,0,.483-.481q0-.842,0-1.685a.44.44,0,0,1,.377-.455.447.447,0,0,1,.509.362,1.177,1.177,0,0,1,.011.161c0,.526,0,1.051,0,1.577a1.357,1.357,0,0,1-.417,1.047,1.262,1.262,0,0,1-.891.361h-4.4A1.318,1.318,0,0,1,.013,47.82c0-.017-.008-.035-.013-.052V43.014",
    transform: "translate(0 -41.014)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32844",
    "data-name": "Path 32844",
    d: "M132.914,3.169a.456.456,0,0,1-.36.331.441.441,0,0,1-.523-.427c0-.485,0-.969,0-1.454V1.53c-.038.008-.054.036-.074.056L128.43,5.1a.446.446,0,1,1-.673-.586c.024-.027.05-.052.075-.077L131.326.956l.059-.062A.131.131,0,0,0,131.3.882h-1.457a.444.444,0,0,1-.222-.828A1.237,1.237,0,0,1,129.739,0h2.852a.514.514,0,0,1,.324.323Z",
    transform: "translate(-125.021)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal7List);
export default __webpack_public_path__ + "static/media/External 7_List.882eb676fac3a0b5f3f9b009d798b670.svg";
export { ForwardRef as ReactComponent };